export default __webpack_public_path__ + "static/media/Titlepage.3faa886b.txt";